<div class="add-lesson-container">
  <div class="top-section">
    <div class="title">
      <div class="main-title">Add a new Lesson</div>
      <div class="sub-title">
        <!-- Lorem ipsum, dolor sit amet consectetur adipisicing. -->
      </div>
    </div>
    <div class="close-btn" (click)="onClickCancel()">
      <i class="fa-solid fa-xmark"></i>
    </div>
  </div>
  <div class="form-section" [formGroup]="lessonForm">
    <div class="left-section">
      <input
        name="title"
        formControlName="title"
        autocomplete="off"
        placeholder="title"
      />
      <textarea
        name="description"
        id=""
        formControlName="description"
        cols="30"
        rows="10"
        placeholder="description"
      ></textarea>
      <input
        type="text"
        autocomplete="off"
        formControlName="duration"
        placeholder="lesson duration"
      />
    </div>
    <div class="right-section">
      <input
        type="number"
        placeholder="serial number"
        formControlName="serialNo"
      />
      <input
        type="file"
        id="file-input"
        (change)="onFileUpload($event)"
        autocomplete="off"
        accept="video/*"
        placeholder="upload a file"
      />
      <label for="file-input">
        <span class="text">Upload a file</span>
        <span class="file-text">{{ fileName }}</span>
      </label>
      <div class="checkbox">
        <input type="checkbox" formControlName="isPreview" id="isPreview" />
        <label for="isPreview">is preview video?</label>
      </div>
      <!-- <input type="file" autocomplete="off" placeholder="upload a course material">
      <input name="title" autocomplete="off" placeholder="specific course fee" /> -->
    </div>
  </div>
  <div class="btn-section">
    <button type="submit" *ngIf="isLoading && !isUpdate">
      Creating
      <i class="fa-solid fa-spinner fa-spin"></i>
    </button>
    <button type="submit" *ngIf="isLoading && isUpdate">
      Updating
      <i class="fa-solid fa-spinner fa-spin"></i>
    </button>
    <button
      type="submit"
      *ngIf="!isUpdate && !isLoading"
      (click)="onCreateLesson()"
    >
      Create Lesson
    </button>
    <button
      type="submit"
      *ngIf="isUpdate && !isLoading"
      (click)="onUpdateLesson()"
    >
      Update Lesson
    </button>
    <!-- <small class="required-error">Please enter required fields!</small> -->
  </div>
</div>
